import { TbFileText, TbX } from "solid-icons/tb";
import { type Component, Show } from "solid-js";

interface TranscriptDocumentProps {
  /** Stamped as `data-media-id` so a host can scroll this row into view by id. */
  mediaId?: string;
  filename: string;
  /** While true, the row renders dimmed and without controls. */
  pending?: boolean;
  /**
   * When provided (and not pending), a hover-revealed remove control is
   * rendered. Removing detaches the document from the transcript; the
   * underlying asset stays in the project library.
   */
  onRemove?: () => void;
}

// Presentational only: a document dropped or picked into the transcript,
// rendered as a filename row rather than inline content — its contents reach
// the model through knowledge base search, not the transcript itself.
export const TranscriptDocument: Component<TranscriptDocumentProps> = (props) => (
  <div
    data-media-id={props.mediaId}
    class="group/document relative my-2 flex max-w-full min-w-0 items-center gap-1.5 pr-7"
  >
    <TbFileText class="size-3.5 shrink-0 text-accent/70" aria-hidden="true" />
    <span
      classList={{ "opacity-60": props.pending }}
      class="min-w-0 truncate text-sm text-primary-text transition-opacity"
      title={props.filename}
    >
      {props.filename}
    </span>
    <Show when={!props.pending && props.onRemove}>
      {/* Revealed on focus as well as hover, so it is reachable from the keyboard. */}
      <button
        type="button"
        aria-label="Remove from session"
        title="Remove from session"
        onClick={() => props.onRemove?.()}
        class="absolute top-0 right-0 hidden rounded-full border border-primary-border bg-canvas/90 p-1 text-primary-text group-focus-within/document:block group-hover/document:block hover:bg-panel-hover focus:ring-2 focus:ring-brand focus:outline-none"
      >
        <TbX class="size-4" />
      </button>
    </Show>
  </div>
);
